import { useAppDispatch } from "@/hooks/useAppDispatch";
import { householdActions } from "@/redux/household/household-slice";
import { useEffect } from "react";
import { Link } from "react-router-dom";

type Props = {
  isFullscreen?: boolean;
  isPageNotFound?: boolean;
};
export default function NoDataMessage({ isFullscreen = true, isPageNotFound = false }: Props) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isPageNotFound)
      dispatch(householdActions.setHeader({ title: "Page not found!", content: "" }));

    return () => {
      if (isPageNotFound) dispatch(householdActions.setHeader({ title: "", content: "" }));
    };
  }, [dispatch, isPageNotFound]);

  return (
    <div
      className={`flex flex-col items-center justify-center text-neutral-100 ${
        isFullscreen ? "h-[calc(100dvh-33rem)]" : ""
      }`}
    >
      <img src="/no-data.svg" />
      {isPageNotFound ? (
        <Link
          to="/household"
          className="text-xl text-primary transition-colors duration-200 hover:opacity-70"
        >
          Go back to household list
        </Link>
      ) : (
        <span className="text-2xl font-medium">No data to display</span>
      )}
    </div>
  );
}
